export var genericStandards = {
            "E" : "Exceptional Performance well exceeds expectations and is consistently outstanding.",
            "A" : "Above Expectations. Performance is consistently beyond expectations.",
            "S" : "Solid Performance. Performance consistently fulfills expectations and at times exceeds them.",
            "I" : "Improvement Needed. Performance does not consistently meet expectations.",
            "U" : "Unsatisfactory. Performance is consistently below expectations. Deficiencies should be addressed as noted in the performance appraisal.",
            ""  : "Not Yet Selected"
};
